import { Button, LuIcon, useLayoutContext } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { forwardRef, memo, useCallback } from "react"

import { SLIDE_OUT_IDS } from "../../layouts"
import { modelIconMapping } from "../../mappings/icons"

export const MapFilterButton = memo(
	forwardRef<HTMLButtonElement, NonNullable<unknown>>((_props, ref) => {
		const { setOpen } = useLayoutContext()

		const handleClick = useCallback(() => {
			setOpen(SLIDE_OUT_IDS.RIGHT, true)
		}, [setOpen])

		return (
			<Link to="/$organizationId/$projectId" from="/$organizationId/$projectId" search={undefined}>
				<Button ref={ref} onClick={handleClick} aria-label="filter" variant="soft">
					<LuIcon icon={modelIconMapping.filter} />
					Filter
				</Button>
			</Link>
		)
	}),
)
